import type Handsontable from 'handsontable/base';

/**
 * Returns whether the Handsontable instance is still safe to use.
 */
export const isHotInstanceAvailable = (hotInstance?: Handsontable | null): hotInstance is Handsontable =>
    !!hotInstance && !hotInstance.isDestroyed;
